import type { ReactNode } from 'react';
import { ExportMenu } from './ExportMenu';
import { InfoTooltip } from './InfoTooltip';

/** A titled card around one data table, with CSV/PNG download of what it shows. */
export function TableCard({
  title,
  info,
  caption,
  empty,
  emptyText,
  children,
}: {
  title: string;
  info?: string;
  caption?: string;
  empty: boolean;
  emptyText: string;
  /** The table's `thead` and `tbody`. */
  children: ReactNode;
}) {
  return (
    <div data-export-root className="rounded-card border border-border bg-surface p-5 shadow-sm">
      {!empty && <ExportMenu title={title} className="float-right -mr-2 -mt-2 ml-2" />}
      <h3 className="flex items-center gap-1.5 text-sm font-medium text-text-default">
        {title}
        {info && <InfoTooltip text={info} />}
      </h3>
      {caption && <p className="mt-1 text-xs text-text-muted">{caption}</p>}
      {empty ? (
        <p className="mt-4 text-sm text-text-muted">{emptyText}</p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-left text-sm">{children}</table>
        </div>
      )}
    </div>
  );
}
